"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BidStrategyResponseToJSON = exports.BidStrategyResponseFromJSONTyped = exports.BidStrategyResponseFromJSON = exports.BidStrategyResponse = void 0;
/**
 * Strategy for how bids will be applied in the auction. Allowed values:
 *  - "MAX_BID": The bid_micro_amount will act as a bid cap, meaning the maximum amount paid
 * per 1000 impressions.
 *  - "UNSET": Ad sets that were pre-auction will not have a bid strategy set.
 *
 * @export
 */
exports.BidStrategyResponse = {
    CostPerResult: 'COST_PER_RESULT',
    MaxBid: 'MAX_BID',
    Unset: 'UNSET'
};
function BidStrategyResponseFromJSON(json) {
    return BidStrategyResponseFromJSONTyped(json, false);
}
exports.BidStrategyResponseFromJSON = BidStrategyResponseFromJSON;
function BidStrategyResponseFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BidStrategyResponseFromJSONTyped = BidStrategyResponseFromJSONTyped;
function BidStrategyResponseToJSON(value) {
    return value;
}
exports.BidStrategyResponseToJSON = BidStrategyResponseToJSON;
